import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import AuthLayout from './components/layout/AuthLayout';
import MainLayout from './components/layout/MainLayout';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import HomePage from './pages/HomePage';
import OrderPage from './pages/OrderPage';
import RideTrackingPage from './pages/RideTrackingPage';
import RideTrackingListPage from './pages/RideTrackingListPage';
import ProfilePage from './pages/ProfilePage';
import RideHistoryPage from './pages/RideHistoryPage';
import PaymentPage from './pages/PaymentPage';
import ErrorPage from './pages/ErrorPage';

function App() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AuthProvider>
        <SnackbarProvider>
          <Routes>
            {}
            <Route path="/" element={<AuthLayout />}>
              <Route index element={<LoginPage />} />
              <Route path="login" element={<LoginPage />} />
              <Route path="register" element={<RegisterPage />} />
            </Route>

            {}
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <MainLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<HomePage />} />
              <Route path="order" element={<OrderPage />} />
              <Route path="track/:rideId" element={<RideTrackingPage />} />
              <Route path="track" element={<RideTrackingListPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="history" element={<RideHistoryPage />} />
              <Route path="payment" element={<PaymentPage />} />
            </Route>

            {}
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </SnackbarProvider>
      </AuthProvider>
    </Box>
  );
}

export default App;
